import { ApolloProvider } from '@apollo/client';
import '@mantine/carousel/styles.css';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { apolloClient } from './apollo';
import './assets/goldplay/fonts.css';
import { LoadCapacitorInitialState } from './components/load-capacitor-initial-state';
import { LayoutContextProvider, ShoppingCartProvider } from './contexts';
import './main.css';
import { router } from './router';
import { Routes } from './routes';
import { theme } from './theme';

// Register the router instance for type safety
declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router;
	}
}

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<LoadCapacitorInitialState>
			<ApolloProvider client={apolloClient}>
				<MantineProvider theme={theme}>
					<ShoppingCartProvider>
						<LayoutContextProvider>
							<Routes />
						</LayoutContextProvider>
					</ShoppingCartProvider>
				</MantineProvider>
			</ApolloProvider>
		</LoadCapacitorInitialState>
	</StrictMode>
);
